module.exports = __webpack_public_path__ + "static/media/sinister_grey.a1ffa8ac.svg";